<template lang="pug">
  app-dialog-confirm(v-model="$_show" @confirm="deleteJudge()")
    app-card-title.mt-5 Вы точно хотите удалить судью?
</template>

<script>
import { AppDialogToggable } from '@/components'
import { judgeService } from "@/_services";
import { mapState, mapMutations } from 'vuex'

export default {
  mixins: [AppDialogToggable],

  computed: {
    ...mapState('judgeReestr', ['currentJudge'])
  },
  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    deleteJudge () {
      this.currentJudge.archive = true 
      this.currentJudge.butterflynet = true
      judgeService.updateJudge(this.currentJudge).then(data => this.setJudgeInJudges(data))
    },
  }
}
</script>